import { render, staticRenderFns } from "./newsBox.vue?vue&type=template&id=4e3e29b6&scoped=true"
import script from "./newsBox.vue?vue&type=script&lang=js"
export * from "./newsBox.vue?vue&type=script&lang=js"
import style0 from "./newsBox.vue?vue&type=style&index=0&id=4e3e29b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e29b6",
  null
  
)

export default component.exports